class Network {
  constructor(api) {
    this.api = api;
  }

  getAllCountries(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/net-ops/graph")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getHierarchyChildrenByType(type, id, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/net-ops/graph?" + type + "=" + id)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  executeFailureAnalysis(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/net-ops/failure-analysis", data)
      .then(resp => {
        onSuccess(resp.data.data);
      })
      .catch(error => {
        onError(error);
      });
  }

  executeSinglePointFailure(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/net-ops/spf", data)
      .then(resp => {
        onSuccess(resp.data.data);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Network;



// WEBPACK FOOTER //
// ./src/api/network.js